import { Component, input } from '@angular/core';

@Component({
    selector: 'loading-icon',
    templateUrl: './loading-icon.component.html',
    styleUrls: ['./loading-icon.component.scss']
})
export class LoadingIconComponent {
    size = input<'small' | 'medium' | 'large'>('medium');
}
